import { EXPRESS_API } from 'configs/api/expressApi';
import axios from 'axios';
import { prepareImageNameForUpload } from 'lib/utils/files';

export const useUploadImage = () => {
  const uploadImage = async (
    file: File,
    userId: number | string,
    onProgress?: (progress: number) => void
  ) => {
    onProgress?.(0);
    const data = {
      fileName: prepareImageNameForUpload(file.name, userId),
      mineType: file.type,
    };
    const response = await EXPRESS_API.post(`/aws/signedurl/user-images`, data);
    const url = response.data.uploadUrl;

    await axios.put(url, file, {
      headers: { 'content-type': file.type },
      onUploadProgress: progressEvent => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress?.(percentCompleted);
        }
      },
    });

    const downloadUrl = response.data.downloadUrl;
    onProgress?.(100);
    return downloadUrl;
  };

  return { uploadImage };
};
